import { render, staticRenderFns } from "./atividade.vue?vue&type=template&id=488ca3de&"
import script from "./atividade.vue?vue&type=script&lang=js&"
export * from "./atividade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports